// ======================================================================
// File Name       : ContentDocumentContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import moment from 'moment';
import { Field, reduxForm, isInvalid, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import ContentDocumentSearch from '../../components/content/ContentDocumentSearch';
import ContentDocumentList from '../../components/content/ContentDocumentList';
import DialogConfirm from '../../components/DialogConfirm';
import * as ContentDocumentAction from '../../actions/content/ContentDocumentAction';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { DATA_AFFIILIATION_TYPE_STR } from '../../constants/ContentConstant';
import { VALIDATE_TYPE, RETURN_MAX_NUM, DEFAULT_DATE_FORMAT_SERVER } from '../../constants/index';
import RenderField from '../../utils/ReduxFormUtils';
import Header from '../../components/Header';
import MessageSearch from '../../components/MessageSearch';
import { CONTENT_DOCUMENT_DETAIL, CONTENT_DOCUMENT_LIST } from '../../constants/PathConstants';
import * as actionType from '../../constants/actionTypes/page';
import { Col } from 'react-bootstrap';
import CustomLink from '../../components/button/CustomLink';
import * as Path from '../../constants/PathConstants';
import * as ICON from '../../constants/IconConstants';

class ContentDocumentContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterData: {},
      showExportModal: false,
      isAllowShowSearchMessage: false,
    };
    this.initData = this.initData.bind(this);
    this.clickSearchButton = this.clickSearchButton.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.onExportDialogCancel = this.onExportDialogCancel.bind(this);
    this.onExportDialogOk = this.onExportDialogOk.bind(this);
    this.openExportDialog = this.openExportDialog.bind(this, MessageTemplate.BULK_EXPORT, null);
    this.createParams = this.createParams.bind(this);
    this.goToDetail = this.goToDetail.bind(this);
    this.searchData = this.searchData.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  componentWillMount() {
    const { searchCondition } = this.props;
    const filterData = {
      ...this.state,
      filterData: searchCondition,
    };
    this.setState(
      filterData,
    );
    this.initData();
  }

  componentWillUnmount() {
    const { formValues } = this.props;
    this.props.dispatch({
      type: actionType.SAVE_SEARCH_CONDITION,
      parentPath: CONTENT_DOCUMENT_LIST,
      searchCondition: formValues,
    });
  }

  initData() {
    const { initialValues } = this.props;
    let column = null;
    let startPosition = 0;
    if (initialValues) {
      if (initialValues.documentSortType) {
        column = initialValues.documentSortType;
      }
      if (initialValues.startPosition) {
        startPosition = initialValues.startPosition;
      }
    }
    const param = this.createParams(false, initialValues, column, startPosition);
    this.props.dispatch(ContentDocumentAction.searchDocumentList(param));
  }

  searchData(startPosition, column) {
    const { formValues, invalid, dispatch } = this.props;
    const { filterData } = this.state;
    if (invalid) {
      return;
    }
    const paramSearch = this.createParams(false, filterData, column, startPosition);
    this.props
      .dispatch(
        ContentDocumentAction.searchDocumentList(paramSearch),
      )
      .then(() => {
        this.setState({ isAllowShowSearchMessage: true });
      });
  }

  goToDetail(contentSecernId) {
    const { invalid, formValues } = this.props;
    if (!invalid) {
      this.props.dispatch({
        type: actionType.SAVE_SEARCH_CONDITION,
        parentPath: CONTENT_DOCUMENT_LIST,
        searchCondition: formValues,
      });
    }
    const path = CONTENT_DOCUMENT_DETAIL.replace(':id', contentSecernId);
    this.props.history.push(path);
  }

  clickSearchButton() {
    const { dispatch, formValues, invalid } = this.props;
    if (invalid) {
      return;
    }
    const filterData = {
      ...this.state.filterData,
      contentSecernIds: formValues.contentSecernIds,
      contentName: formValues.contentName,
      documentUpdateStatus: formValues.documentUpdateStatus,
      createdDateFrom: formValues.createdDateFrom,
      createdDateTo: formValues.createdDateTo,
      dataAffiliationType: formValues.dataAffiliationType,
      documentSortType: formValues.documentSortType,
      ascendingDescendingSort: formValues.ascendingDescendingSort,
      startPosition: formValues.startPosition,
      createdUserName: formValues.createdUserName, // Step 9.0.0
    };
    this.setState({ filterData }, () => {
      const paramSearch = this.createParams(false, filterData, null, 0);
      this.props.change('startPosition', 0);
      this.props.change('documentSortType', null);
      this.props.change('ascendingDescendingSort', null);
      this.props.dispatch(ContentDocumentAction.searchDocumentList(paramSearch))
      .then(() => {
        this.setState({ isAllowShowSearchMessage: true });
      });
    });
  }

  openExportDialog(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showExportModal: true });
  }
/**
 * Action click cancel button in dialog
 */
  onExportDialogCancel() {
    this.setState({ showExportModal: false });
  }

/**
 * Action click OK button in diablog
 */
  onExportDialogOk() {
    const paramExport = this.createParams(true, this.props.filterData);
    this.props.dispatch(ContentDocumentAction.searchDocumentList(paramExport));
    this.setState({ showExportModal: false });
  }

  /**
   * Paging
   */
  getStartEndData(startPosition) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let column = null;
    if (formValues.documentSortType) {
      column = formValues.documentSortType;
    }
    this.searchData(startPosition, column);
  }
  /**
   * Handle sort table
   */
  handleSortState(column) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let startPosition = null;
    if (formValues.startPosition) {
      startPosition = formValues.startPosition;
    }
    this.searchData(startPosition, column);
  }

  createParams(isCSV, data, column, startPosition) {
    const listTemp = [];
    const filterData = {};
    if (data && data.createdDateFrom) {
      const createdDateFrom = data.createdDateFrom ? moment(data.createdDateFrom).startOf('day').format(DEFAULT_DATE_FORMAT_SERVER) : '';
      filterData.createdDateFrom = createdDateFrom;
    }
    if (data && data.createdDateTo) {
      const createdDateTo = data.createdDateTo ? moment(data.createdDateTo).endOf('day').format(DEFAULT_DATE_FORMAT_SERVER) : '';
      filterData.createdDateTo = createdDateTo;
    }
    if (data && data.contentSecernIds) {
      filterData.contentSecernId = data.contentSecernIds;
    }
    if (data && data.dataAffiliationType) {
      filterData.dataAffiliationType = parseInt(data.dataAffiliationType, 10) < 0 ? null : parseInt(data.dataAffiliationType, 10);
    }
    if (data && data.contentName) {
      filterData.contentName = data.contentName;
    }
    if (data && data.documentUpdateStatus) {
      filterData.documentUpdateStatus = data.documentUpdateStatus !== null ? parseInt(data.documentUpdateStatus, 10) : null;
    }
    // Step 9.0.0 START
    if (data && data.createdUserName) {
      filterData.createdUserName = data.createdUserName;
    }
    // Step 9.0.0 END

    if (!isNaN(parseInt(startPosition, 10))) {
      filterData.startPosition = startPosition;
    }

    if (column && Object.keys(column).length) {
      filterData.ascendingDescendingSort = column.sortState;
      filterData.documentSortType = column.sortBy;
    }

    if (!column) {
      filterData.ascendingDescendingSort = null;
      filterData.documentSortType = null;
    }

    let selectTargetData = 0;
    if (isCSV) {
      selectTargetData = 1;
    }
    if (!startPosition) {
      filterData.startPosition = 0;
    }
    filterData.returnMaxNum = RETURN_MAX_NUM;
    const param = {
      selectTargetData,
      searchInfo: filterData,
    };
    return param;
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  render() {
    const { documentContentList, contentDocumentList, filterData, invalid } = this.props;
    const { allSecernIds } = documentContentList;
    const { hoverIndex } = this.state;
    return (
      <div>
        <Header name='ドキュメント' />
        <MessageSearch
          recordNum={this.props.recordNum}
          resultList={allSecernIds || []}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <Col sm={12} className="float-end padding-left-right-clear align-right">
          <CustomLink
            className="margin-right-7 link-authority bold inline-flex line-height-20"
            to={Path.MULTI_LANGUAGE_LIST}
            text="多言語対応"
            icon={ICON.APPS}
          />
        </Col>
        <ContentDocumentSearch
          {...this.props.filterData}
          recordNum={this.props.recordNum}
          onSearchBtnClick={this.props.handleSubmit(this.clickSearchButton)}
          getStartEndData={this.getStartEndData}
          openExportDialog={this.openExportDialog}
        />
        <ContentDocumentList
          documentContentList={documentContentList}
          handleSortState={this.handleSortState}
          goToDetail={this.goToDetail}
          invalid={invalid}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          hoverIndex={hoverIndex}
          recordNum={this.props.recordNum}
          getStartEndData={this.getStartEndData}
        />
        <DialogConfirm
          showModal={this.state.showExportModal}
          onCancel={this.onExportDialogCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onExportDialogOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { documentContentList } = state.document;
  let { filterData } = state.document;
  const { parentPath, searchCondition } = state.page;
  const { contentDocumentList } = state.form;
  filterData = contentDocumentList && contentDocumentList.values ?
        contentDocumentList && contentDocumentList.values : filterData;
  const recordNum = documentContentList.recordNum;
  const csvFileLink = documentContentList.csvFileLink;
  const invalid = isInvalid('contentDocumentList')(state);
  let initial = filterData;
  if (parentPath === CONTENT_DOCUMENT_LIST) {
    const paramSearch = {};
    if (searchCondition) {
      paramSearch.contentSecernIds = searchCondition.contentSecernIds;
      paramSearch.contentName = searchCondition.contentName;
      paramSearch.documentUpdateStatus = searchCondition.documentUpdateStatus;
      paramSearch.createdDateFrom = searchCondition.createdDateFrom;
      paramSearch.createdDateTo = searchCondition.createdDateTo;
      paramSearch.dataAffiliationType = searchCondition.dataAffiliationType;
      paramSearch.documentSortType = searchCondition.documentSortType;
      paramSearch.ascendingDescendingSort = searchCondition.ascendingDescendingSort;
      paramSearch.startPosition = searchCondition.startPosition;
      paramSearch.createdUserName = searchCondition.createdUserName; // Step 9.0.0
    }
    initial = paramSearch;
  }
  return {
    ...{ documentContentList },
    ...{ contentDocumentList },
    filterData,
    initialValues: initial,
    recordNum,
    csvFileLink,
    invalid,
    formValues: getFormValues('contentDocumentList')(state),
    searchCondition,
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'contentDocumentList', // a unique identifier for this form
  touchOnChange: true,
})(ContentDocumentContainer));
